import React from 'react';
import { StyleSheet, View } from 'react-native';

import { webOnlyStyles } from '../../../utils';
import { useStyleSwitch } from '../../../hooks/useStyleSwitch';
import type { ChipBoxProps, ChipState } from '../Chip.types';
import { COLORS } from '@garnish/constants';
import { boxStyles as boxStylesConfig } from '../styles';

export const ChipBox = ({ focused, state, children, style }: ChipBoxProps) => {
  const useBoxStyles = useStyleSwitch<ChipState>('state', boxStylesConfig);
  const boxStyles = useBoxStyles(state);

  return (
    <View
      style={[
        styles.box,
        boxStyles,
        focused
          ? /* if I move this down into StyleSheet.create({}), it fails  */
            webOnlyStyles({
              outlineWidth: 2,
              outlineColor: COLORS.LAVENDER,
              outlineStyle: 'solid',
            })
          : {},
        style,
      ]}
    >
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  box: {
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderWidth: 1,
    borderRadius: 24,
    borderColor: COLORS.NEUTRAL_3,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
